import { observer } from 'mobx-react';
import { localeStore } from 'src/mobx/localesStore';
import { promocodeStore } from 'src/view/screens/MarketingScreen/screens/PromocodesScreen/store/promocodeStore';
import Input from '~/view/components/Controls/InputComponent/Input';
import Text from '~/view/components/Text/Text';
import './style.scss';

const PromocodeIdExternal = observer((): JSX.Element => {
  const onChangeExternalId = (value: string | undefined) => {
    promocodeStore.changePromocode({ external_id: value }, true);
  };

  return (
    <div className="mt-6">
      <Text type="block-header" text="external_id" />
      <Input
        value={promocodeStore.promocode.external_id}
        onChangeValue={onChangeExternalId}
        placeholder={localeStore.t('external_id_placeholder')}
        contentClassName="promocode_large_field mt-2"
      />
    </div>
  );
});

export default PromocodeIdExternal;
